<template>
  <div class="card" :class="darkMode ? 'bg-gradient-dark' : ''">
    <div class="px-2 py-1 card-body">
      <div
        class="timeline-one-side"
        :data-timeline-axis-style="darkMode ? 'dashed' : 'dotted'"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimelineList",
  props: {
    title: {
      type: String,
      default: ""
    },
    description: {
      type: String,
      default: ""
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>
